module.exports = __webpack_public_path__ + "media/images/icon__warning@2x-d5d28d24ddc2af2e6a369c38b1f9943a.png";